import { fromJS } from 'immutable'
import {
  DEPARTMENT_DEACTIVATE_REQUEST,
  DEPARTMENT_DEACTIVATE_SUCCESS,
  DEPARTMENT_DEACTIVATE_FAILURE,
  DEPARTMENT_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DEPARTMENT_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case DEPARTMENT_DEACTIVATE_SUCCESS:
      return state
        .set('departmentDeactivate', fromJS(action.payload.deletedDepartment))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case DEPARTMENT_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('departmentDeactivate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case DEPARTMENT_DEACTIVATE_RESET:
      return state
        .delete('departmentDeactivate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/department/department-deactivate-reducer.js